/**
 * @generated SignedSource<<3487d82f193adae34805b3f81c42ff3c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveJiraInstanceInput = {
  uuid: any;
};
export type RemoveJiraInstanceMutation$variables = {
  input: RemoveJiraInstanceInput;
};
export type RemoveJiraInstanceMutation$data = {
  readonly removeJiraInstance: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly removed: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type RemoveJiraInstanceMutation = {
  response: RemoveJiraInstanceMutation$data;
  variables: RemoveJiraInstanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveJiraInstancePayload",
        "kind": "LinkedField",
        "name": "removeJiraInstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RemoveJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveJiraInstancePayload",
        "kind": "LinkedField",
        "name": "removeJiraInstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b90672b337465bed5ad2d8da73394b09",
    "id": null,
    "metadata": {},
    "name": "RemoveJiraInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveJiraInstanceMutation(\n  $input: RemoveJiraInstanceInput!\n) {\n  removeJiraInstance(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    removed {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "854ea00dfe6ef86faa2e6e3a4610d3dc";

export default node;
